import React, { Component } from 'react';
import { Line } from "react-chartjs-2";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
  } from 'chart.js';
import { buildPerformanceTimeline } from "../utils/tradeStats";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);


class PositionsLineGraph extends Component {
    formatDateOnly = (dateValue) => {
        if (!dateValue) return "";
        const asString = String(dateValue);
        if (asString.includes(" ")) return asString.split(" ")[0];
        if (asString.includes("T")) return asString.split("T")[0];
        return asString;
    };

    render() {
        const statsData = this.props.data;
        const positions = this.props.positions || [];
        const cashflows = this.props.cashflows || [];
        const isMobile = typeof window !== "undefined" && window.innerWidth <= 768;
        const axisFontSize = isMobile ? 7 : 12;
        const axisTitleFontSize = isMobile ? 9 : 12;
        const timeline = buildPerformanceTimeline(positions, cashflows, statsData.initial_balance);
        const dateList = timeline.points.map((point) => this.formatDateOnly(point.time));
        const balanceList = timeline.points.map((point) => Number(point.balance.toFixed(2)));
        const drawdownList = timeline.points.map((point) => Number(point.drawdownPercent.toFixed(2)));

        const data = {
          labels: dateList,
          datasets: [
              {
                  label: "Balance",
                  data: balanceList,
                  fill: true,
                  borderColor: "#2c9c91",
                  borderWidth: 2,  // Make lines thinner
                  pointRadius: 3,  // Reduce point size
                  pointHoverRadius: 5, // Keep hover effect readable
                  yAxisID: "y",
              },
              {
                  label: "Drawdown %",
                  data: drawdownList,
                  fill: false,
                  borderColor: "#ff7b72",
                  backgroundColor: "#ff7b72",
                  borderWidth: 2,
                  borderDash: [6, 4],
                  pointRadius: 2,
                  pointHoverRadius: 4,
                  yAxisID: "yDrawdown",
              }
          ]
        };
        const config = {
        responsive: true,
        maintainAspectRatio: false,
        layout: {
            padding: 0,
        },
        interaction: {
            mode: "index",
            intersect: false,
        },
        plugins: {
            legend: {
                position: 'top',
                labels: {
                    color: "#f8f9fa",
                },
            },
            tooltip: {
                callbacks: {
                    label: (context) => {
                        const label = context.dataset.label || "";
                        const value = context.parsed.y;
                        if (context.dataset.yAxisID === "yDrawdown") {
                            return `${label}: ${value}%`;
                        }
                        return `${label}: £${value}`;
                    },
                    afterLabel: (context) => {
                        if (context.dataset.yAxisID !== "y") {
                            return "";
                        }
                        const point = timeline.points[context.dataIndex];
                        if (!point || point.eventType !== "cashflow") {
                            return "";
                        }
                        const sign = point.amount >= 0 ? "+" : "";
                        return `Cash flow: ${sign}£${Number(point.amount).toFixed(2)}`;
                    },
                },
            },
        },
        scales: {
            x: {
                display: !isMobile,
                ticks: {
                    autoSkip: true,
                    maxRotation: isMobile ? 45 : 30,
                    minRotation: isMobile ? 45 : 30,
                    color: "#f8f9fa",
                    display: !isMobile,
                    padding: isMobile ? 0 : 3,
                    font: {
                        size: axisFontSize,
                    },
                }
            },
            y: {
                ticks: {
                    color: "#f8f9fa",
                    padding: isMobile ? 1 : 3,
                    font: {
                        size: axisFontSize,
                    },
                    callback: (value) => `£${value}`,
                },
                title: {
                    display: !isMobile,
                    text: "Balance",
                    color: "#f8f9fa",
                    font: {
                        size: axisTitleFontSize,
                    },
                },
                grid: {
                    color: "rgba(248, 249, 250, 0.12)",
                },
            },
            yDrawdown: {
                position: "right",
                min: 0,
                ticks: {
                    color: "#ffb4ae",
                    padding: isMobile ? 1 : 3,
                    font: {
                        size: axisFontSize,
                    },
                    callback: (value) => `${value}%`,
                },
                title: {
                    display: !isMobile,
                    text: "Drawdown",
                    color: "#ffb4ae",
                    font: {
                        size: axisTitleFontSize,
                    },
                },
                grid: {
                    drawOnChartArea: false,
                },
            },
        }
        };

        return (
            <Line
                data={data}
                options={config}
            />
        );
    }
}
export default PositionsLineGraph;
